import React, { Children, cloneElement, isValidElement } from 'react';

//used to remove aria-label for '<th>' in AntD Table for WCAG.
const CustomTh = (props) => {
    // The !! operator checks for '', null, and undefined.
    const hasAriaLabel = !!props['aria-label'];

    let propsToSpread;

    if (hasAriaLabel) {
        propsToSpread = props;
    } else {
        const { 'aria-label': ariaLabel, ...restPropsWithoutAriaLabel } = props;
        propsToSpread = restPropsWithoutAriaLabel;
    }

    const { onClick, ...thProps } = propsToSpread;

    const recursivelyCloneChildren = (children) => {
        return Children.map(children, child => {
            if (!isValidElement(child)) {
                return child;
            }

            if (
                child.props.className &&
                child.props.className.includes('ant-table-column-sorters')
            ) {
                return cloneElement(child, {
                    onClick: onClick,
                    style: { cursor: 'pointer' },
                });
            }

            if (child.props.children) {
                return cloneElement(child, {
                    children: recursivelyCloneChildren(child.props.children),
                });
            }

            return child;
        });
    };

    const modifiedChildren = recursivelyCloneChildren(thProps.children);

    return (
        <th {...thProps}>
            {modifiedChildren}
        </th>
    );
}

export default CustomTh;